import React from 'react';
import './Option.css';

const Option = (props) => (
    <div className="Option">
        {props.title}
    </div>
);

export default Option;